<!-- 
  name: 短信包
  desc: 催收模块-短信包
  auth: dhx
  update: 2024/2/22
 -->
<template>
  <div class="sms-package d-c-c">
    <div class="sms-wrapper">
      <div class="sms-title d-s-c d-r">
        <i class="el-icon-message"></i>
        <h2>短信包管理</h2>
      </div>

      <table class="sms-table">
        <tr v-for="(item, index) in list" :key="index">
          <td class="table-key">{{ item.name }}</td>
          <td>
            {{ item.value }}
            <el-button v-if="item.button" type="primary" size="small" @click="openModel">
              {{ item.button.text }}
            </el-button>
          </td>
        </tr>
      </table>
    </div>

    <buy-model ref="dialogRef"></buy-model>
  </div> 
</template>

<script>
import options from './contact'
export default options;
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>



// WEBPACK FOOTER //
// src/views/collection/sms_package/index.vue